import { sdkRequest } from '@eb/http';

import { keysCamelToSnake } from '@eb/transformation-utils';
import { getDiscoveryRequestPayload } from '../utils/analytics';

const internalClickTrackingUrl = '/api/v3/destination/search/log_clicks/';
const internalRequestLoggingUrl = '/api/v3/destination/search/log_requests/';

export const trackEventClickInternal = (data) => {
    const internalLoggingPromise = sdkRequest(internalClickTrackingUrl, {
        headers: {
            'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify({
            clicks: [keysCamelToSnake(data)],
        }),
    });

    if (internalLoggingPromise) {
        internalLoggingPromise.catch((err) => {
            // Swallow errors when in prod, too much noise and doesn't affect UX
            if (process.env.NODE_ENV !== 'production') {
                throw err;
            }
        });
    }
};

/*
Takes user info, search context (filters, location, etc), and result information and logs it.

Returns searchId which can be used to log to GA.

If null is returned for the searchId, then something is wrong and the searchId shouldn't be logged to GA.
 */
export const logDiscoveryRequest = ({
    eventSearch,
    publicUserId,
    guestId,
    locationSlug,
    userGenerated,
    navigation,
    action,
    blobField,
    variant,
    resultIds,
    numResults,
}) => {
    const discoveryRequestPayload = getDiscoveryRequestPayload({
        eventSearch,
        publicUserId,
        guestId,
        locationSlug,
        userGenerated,
        navigation,
        action,
        blobField,
        variant,
        resultIds,
        numResults,
    });

    if (!discoveryRequestPayload) {
        return null;
    }

    const internalLoggingPromise = sdkRequest(internalRequestLoggingUrl, {
        headers: {
            'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify({
            requests: [keysCamelToSnake(discoveryRequestPayload)],
        }),
    });

    if (internalLoggingPromise) {
        internalLoggingPromise.catch(() => {
            //swallow error as it has no impact on user
        });
    }

    return discoveryRequestPayload.searchId;
};
